module.exports = __webpack_public_path__ + "img/aquaman.c8c2d70c.jpg";